import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text, useResponsive } from '@common-fe/common-fe';

import TermsAgreementSection from './TermsAgreementSection';

interface Props {
  isReachOutEmployer: boolean;
  hasQualifyingLetters: boolean;
  termsAccepted: boolean;
  isAgreementOpened: boolean;
  isWarningShaking: boolean;
  onOpenAgreement: () => void;
  onToggleTerms: () => void;
  onTriggerShake: () => void;
}

const ReturnedItemsStep: React.FC<Props> = ({
  isReachOutEmployer,
  hasQualifyingLetters,
  termsAccepted,
  isAgreementOpened,
  isWarningShaking,
  onOpenAgreement,
  onToggleTerms,
  onTriggerShake,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <Box
      pad={isMobile ? 'spacing8' : 'spacing24'}
      round={isMobile ? 'container1Round' : 'moduleRound'}
      background="module"
      gap={isMobile ? 'spacing8' : 'spacing24'}
    >
      <Box
        pad={isMobile ? 'spacing16' : 'spacing24'}
        background="canvas"
        round="container1Round"
        border={{ color: 'border2', size: '1px' }}
        gap="spacing16"
        data-testid="bad-address-review_returned-mail-section"
      >
        <Text size="large" color="textBody">
          {t('Returned Mail')}
        </Text>
        {isReachOutEmployer ? (
          <Box
            pad="spacing24"
            background="warningContainer"
            border={{ color: 'warningBorder', size: '1px' }}
            round="fieldRound"
            data-testid="bad-address-review_reach-out-employer"
            style={{ position: 'relative' }}
          >
            <Box
              height="2px"
              round="small"
              background="warning"
              style={{ position: 'absolute', top: '-0.5px', left: '24px', right: '24px' }}
            />
            <Text weight="bold" color="textBody">
              {t('Editing of your address has been displayed by your administrator. Please reach out to your employer to update your address')}
            </Text>
          </Box>
        ) : (
          <Box
            pad="spacing24"
            background="successContainer"
            border={{ color: 'successBorder', size: '1px' }}
            round="fieldRound"
            data-testid="bad-address-review_all-set"
            style={{ position: 'relative' }}
          >
            <Box
              height="2px"
              round="small"
              background="success"
              style={{ position: 'absolute', top: '-0.5px', left: '24px', right: '24px' }}
            />
            <Text weight="bold" color="textBody">
              {t("Your address has been confirmed. You're all set — no further action needed.")}
            </Text>
          </Box>
        )}
      </Box>

      {hasQualifyingLetters && !isReachOutEmployer && (
        <TermsAgreementSection
          termsAccepted={termsAccepted}
          isAgreementOpened={isAgreementOpened}
          isWarningShaking={isWarningShaking}
          onOpenAgreement={onOpenAgreement}
          onToggleTerms={onToggleTerms}
          onTriggerShake={onTriggerShake}
        />
      )}
    </Box>
  );
};

export default ReturnedItemsStep;
